import { safeReturnPath } from './safe-return-path.js'

export async function submitAuth(endpoint, payload, request = fetch) {
  const response = await request(endpoint, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  const result = await response.json().catch(() => null)

  if (!response.ok) {
    throw new Error(result?.error?.message || 'Unable to continue. Try again.')
  }

  return result
}

export function authEmailPrefill(value) {
  return typeof value === 'string' &&
    value.length <= 320 &&
    !/[\u0000-\u001f\u007f]/.test(value)
    ? value.trim()
    : ''
}

export function authSwitchHref(page, next, email) {
  const path = safeReturnPath(next)
  const query = new URLSearchParams()
  if (path !== '/account') query.set('next', path)
  const prefill = authEmailPrefill(email)
  if (prefill) query.set('email', prefill)
  return query.size ? `${page}?${query}` : page
}

export async function completeAuth(request, session, router, next, payload) {
  await request.trigger(payload)
  await session.mutate()
  router.next(next, { replace: true })
}
